import React from 'react'
import styled from 'styled-components/macro'
import { Link } from 'react-router-dom'

import Container from '../../atoms/Container'
import iPhoneSignup from '../../../assets/images/iPhoneSignup.png'
import signupCTABg from '../../../assets/images/CtaBackground.png'
import { Title } from '../../atoms/Typography'
import { Button } from '../../atoms/Button'
import StoreLinks from '../../atoms/StoreLinks'

export default function LoggedInFooter() {
  return (
    <SignupCTA>
      <Container centered inline>
        <Figure>
          <img
            src={iPhoneSignup}
            alt="smart gym app su iphone nella schermata calendario"
          />
        </Figure>
        <Text>
          <Title as="h2" size="32px" weight="800">
            Iscriviti subito
          </Title>
          <p>Per te un'ora in omaggio!</p>
          <Button as={Link} to="iscriviti">
            voglio iscrivermi
          </Button>
        </Text>
        <StoreLinks text="scarica l'app" />
      </Container>
    </SignupCTA>
  )
}

const Text = styled.header`
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  color: #212121;
  font-size: 32px;
  line-height: 45px;

  > a {
    display: inline-block;
    margin-top: 18px;
  }
  @media screen and (max-width: 1023px) {
    > a {
      display: block;
      padding: 11px 30px;
      margin-top: 24px;
    }
  }
`

const SignupCTA = styled.article`
  position: relative;

  background: linear-gradient(
      0deg,
      rgba(254, 126, 54, 0.1),
      rgba(254, 126, 54, 0.1)
    ),
    url(${signupCTABg});
  background-size: contain;
  background-blend-mode: color, multiply;

  @media screen and (max-width: 1023px) {
    padding: 30px 0;
    footer a {
      display: inline-block;
      margin-right: 16px;
      vertical-align: middle;
      margin-bottom: 0;
    }
  }
  @media screen and (min-width: 1024px) {
    height: 330px;
    margin-top: 120px;
  }
`

const Figure = styled.figure`
  width: 280px;
  overflow: hidden;
  margin-top: -60px;

  img {
    vertical-align: top;
    width: 100%;
  }
  @media screen and (max-width: 1023px) {
    display: none;
  }
`
